export default __webpack_public_path__ + "static/media/header_logo.70be9a88.svg";